<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: 0px"></el-header>
        <el-mian style="padding-bottom: 20px; ">
            <div class="custom-title flex items-center md:h-[40px]">
                <span>個人設定 ({{ getUserName() }})</span>
            </div>

            <div class="h-[calc(100vh-122px)] md:h-[calc(100vh-112px)] overflow-y-auto">
                <div class="m-4 p-4" style="border: 2px solid #d1d5db; border-radius: 10px">
                    <p class="text-lg text-bold mb-4">パスワード変更</p>

                    <div class="md:flex md:justify-center">
                        <el-form :model="passwordForm" :rules="rules" ref="formRef" label-width="auto">
                            <div class="hidden md:block md:w-[500px]">
                                <el-form-item label="現在のパスワード:" prop="current_password">
                                    <el-input show-password v-model="passwordForm.current_password" placeholder="現在のパスワード"
                                        autocomplete="off" />
                                </el-form-item>

                                <el-form-item label="新しいパスワード:" prop="password">
                                    <el-input show-password v-model="passwordForm.password" placeholder="新しいパスワード"
                                        autocomplete="off" />
                                </el-form-item>

                                <el-form-item label="新しいパスワード（確認）:" prop="password_confirmation">
                                    <el-input show-password v-model="passwordForm.password_confirmation" placeholder="新しいパスワード（確認）"
                                        autocomplete="off" />
                                </el-form-item>
                            </div>
                            <div class="w-full md:hidden">
                                <el-form-item prop="current_password">
                                    <el-input show-password v-model="passwordForm.current_password" placeholder="現在のパスワード"
                                        autocomplete="off" />
                                </el-form-item>

                                <el-form-item prop="password">
                                    <el-input show-password v-model="passwordForm.password" placeholder="新しいパスワード"
                                        autocomplete="off" />
                                </el-form-item>

                                <el-form-item prop="password_confirmation">
                                    <el-input show-password v-model="passwordForm.password_confirmation" placeholder="新しいパスワード（確認）"
                                        autocomplete="off" />
                                </el-form-item>
                            </div>

                            <div class="mb-6 flex justify-center">
                                <p v-if="errorMessage" class="text-red-500  text-xs">{{ errorMessage }}</p>
                            </div>

                            <div class="flex justify-center">
                                <el-button type="info" class="w-full md:w-80"
                                    @click="handleChangePassword(formRef)">パスワード変更</el-button>
                            </div>
                        </el-form>
                    </div>
                </div>

                <div class="m-4" style="border: 2px solid #d1d5db; border-radius: 10px">
                    <p class="text-lg text-bold m-4">ログイン端末</p>

                    <!-- 手机CARD部 -->
                    <div class="md:hidden" v-loading="loading">
                        <el-card style="border-top: 1px solid #d1d5db; border-bottom: 1px solid #d1d5db; border-radius: 0px"
                            v-for="item in mTableData" :key="item.user_id">
                            <el-row align="middle">
                                <el-col :span="21">
                                    <div>{{ item.user_id }}</div>
                                    <div>{{ item.device + "," + item.browser + "," + item.os }}</div>
                                    <div>{{ item.language + "," + item.timezone }}</div>
                                    <div>{{ item.updated_date }}</div>
                                </el-col>

                                <el-col :span="2" class="ml-2" align="right">
                                    <span class="material-symbols-outlined cursor-pointer" @click="handleDeleteFCMToken(item)">
                                        delete
                                    </span>
                                </el-col>
                            </el-row>
                        </el-card>
                    </div>

                    <!-- WEB表格部 -->
                    <div class="hidden md:block w-full">
                        <el-table :data="mTableData" v-loading="loading">
                            <el-table-column prop="updated_date" label="更新日" />
                            <el-table-column prop="user_id" label="ID" />
                            <el-table-column prop="device" label="デバイス" />
                            <el-table-column prop="browser" label="ブラウザ" />
                            <el-table-column prop="os" label="OS" />
                            <el-table-column prop="language" label="言語" />
                            <el-table-column prop="timezone" label="タイムゾーン" />
                            <el-table-column label="削除" width="52" align="center">
                                <template #default="scope">
                                    <span class="material-symbols-outlined cursor-pointer mt-2" @click="handleDeleteFCMToken(scope.row)">
                                        delete
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-mian>
    </el-container>
</template>

<!-- <template>
    <div class="flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto">
        <div class="w-full h-12 p-4 shadow-md">
            <span class="text-large text-black text-bold font-600 mr-3">個人設定</span>
        </div>

        <div class="flex grid w-full px-6 mt-6 gap-4 mb-6">

            <div class="flex flex-col w-full justify-start border border-gray-300 items-center rounded-md p-4">
                <div class="w-full flex justify-start">
                    <p class="text-large text-black text-bold font-600 mr-3">パスワード変更</p>
                </div>
                

            </div>

            <div class="w-full md:hidden" v-loading="loading">
                <el-card class="mb-4 p-0" style="border: 1px solid #d1d5db; border-radius: 10px"
                    v-for="item in mTableData" :key="item.user_id">
                    <el-row align="middle">
                        <el-col :span="22" class="px-2">
                            <div>{{ item.user_id }}</div>
                            <div>{{ item.device + "," + item.browser + "," + item.os }}</div>
                            <div>{{ item.language + "," + item.timezone }}</div>
                            <div>{{ item.updated_date }}</div>
                        </el-col>

                        <el-col :span="2">
                            <el-row>
                                <span class="material-symbols-outlined cursor-pointer" @click="handleDeleteFCMToken(item)">
                                    delete
                                </span>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <div class="hidden md:block flex flex-col w-full justify-start border border-gray-300 items-center rounded-md p-4">
                <div class="w-full flex justify-start">
                    <p class="text-large text-black text-bold font-600 mr-3">ログイン端末</p>
                </div>
                <el-table :data="mTableData" v-loading="loading">
                    <el-table-column prop="updated_date" label="更新日" />
                    <el-table-column prop="user_id" label="ID" />
                    <el-table-column prop="device" label="デバイス" />
                    <el-table-column prop="browser" label="ブラウザ" />
                    <el-table-column prop="os" label="OS" />
                    <el-table-column prop="language" label="言語" />
                    <el-table-column prop="timezone" label="タイムゾーン" />
                    <el-table-column label="削除" width="52">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer" @click="handleDeleteFCMToken(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <div class="flex grid w-full px-6 mt-6 gap-4 grid-cols-1 lg:grid-cols-2 mb-6">
        </div>
        <div class="flex-1"></div>
    </div>
</template> -->

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { defineComponent, onMounted, ref } from 'vue';
import { Delete } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { SearchRequest } from '@/components/common/request';

interface PersonalSettingInfo{
    user_id: string,
    device: string,
    browser: string,
    os: string,
    language: string,
    timezone: string,
    updated_date?: string,
}

export default defineComponent({
    name: 'PersonalSetting',
    components: {
        Delete,
    },
    setup() {

        const user_name = ref<string>('');

        const passwordForm = ref({
            current_password: '',
            password: '',
            password_confirmation: ''
        });

        const formRef = ref<FormInstance>()
        const rules = ref<FormRules>({
            current_password: [
                { required: true, message: '現在のパスワードを入力してください', trigger: 'blur' },
                { min: 6, max: 20, message: '現在のパスワードは6〜20文字の間で入力してください', trigger: 'blur' }
            ],
            password: [
                { required: true, message: '新しいパスワードを入力してください', trigger: 'blur' },
                { min: 6, max: 20, message: '新しいパスワードは6〜20文字の間で入力してください', trigger: 'blur' },
            ],
            password_confirmation: [
                { required: true, message: '新しいパスワード（確認）を入力してください', trigger: 'blur' },
                { min: 6, max: 20, message: '新しいパスワード（確認）は6〜20文字の間で入力してください', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        if (value !== passwordForm.value.password) {
                            callback(new Error('新しいパスワードと確認用パスワードが一致しません'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
        })

        const errorMessage = ref<string>('');
        const mTableData = ref<PersonalSettingInfo[]>([]);
        const loading = ref<boolean>(false);

        onMounted(() => {
            const user = localStorage.getItem('user');
            if (user) {
                user_name.value = user;
            }
            getFCMToken();
        });

        const handleChangePassword = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    changePassword();
                } else {
                    console.log('フォームの検証に失敗しました!', fields)
                }
            })
        }

        const handleDeleteFCMToken = (row: any) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteFCMToken(row.token);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        }

        /**DB */
        const getFCMToken = () => {
            const user_id = localStorage.getItem('user_id');
            loading.value = true;
            const params:SearchRequest = {
                page: 1,
                limit: 9999,
                user_id: user_id,
            };

            axios.get('/api/notification/get-token', { params }).then(response => {
                mTableData.value = response.data.data;
            }).catch(error => {
                console.error(error);
            }).finally(() => {
                loading.value = false;
            });
        }

        const deleteFCMToken = async (token: string) => {
            try {
                const res = await axios.delete(`/api//notification/delete-token/${token}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getFCMToken();
                } else {
                    ElMessage.error(getErrorMessage(PageType.PERSONAL_SETTING, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.PERSONAL_SETTING));
            }
        }

        const changePassword = async () => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.post('/api/users/change-password', passwordForm.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    ElMessage.success("パスワードの変更に成功しました。");
                    // フォームをリセット
                    if (formRef.value) {
                        formRef.value.resetFields();
                    }
                    errorMessage.value = '';
                } else {
                    throw new Error('パスワードの変更に失敗しました');
                }
            } catch (error) {
                errorMessage.value = 'パスワードの変更に失敗しました。';
                ElMessage.error("パスワードの変更に失敗しました。");
            }
        }

                /**
         * 获取用户名
         */
        // 不需要 async，直接返回字符串即可
        const getUserName = () => {
            const userInfo = localStorage.getItem('user');
            if (userInfo) {
                return userInfo;
            }
            return '';
        }

        return {
            user_name,
            passwordForm,
            errorMessage,
            mTableData,
            loading,
            rules,
            formRef,
            getUserName,
            handleDeleteFCMToken,
            handleChangePassword
        }
    }
});
</script>